import { ZOOM_LEVEL } from './consts';

/**
 * Floor-plan DnD coords under the app's CSS zoom:80% (HeaderLayout).
 *
 * Store 0..1 from client/bbox. Render as `coord * bboxSize / ZOOM_LEVEL` —
 * that /ZOOM_LEVEL is the CSS-zoom compensation (absolute left/top are in
 * layout px, getBoundingClientRect/client offsets are in zoomed viewport px).
 * Do NOT multiply ZOOM_LEVEL into the stored value or pins drift toward top-left.
 */

export const MAP_MARKER_SIZE = 50;

/** Half marker size in zoomed client/viewport px (layout 25px * zoom). */
export const MAP_MARKER_HALF_CLIENT = (MAP_MARKER_SIZE / 2) * ZOOM_LEVEL;

export function getMapCanvasBBox(img) {
  if (!img) return null;
  const rect = img.getBoundingClientRect();
  if (!rect.width || !rect.height) return null;
  return {
    left: rect.left,
    top: rect.top,
    width: rect.width,
    height: rect.height,
  };
}

export function clientToStoredMapCoordinates(img, clientX, clientY) {
  const bbox = getMapCanvasBBox(img);
  if (!bbox) return null;
  return {
    x: Math.round(((clientX - bbox.left) / bbox.width) * 1e10) / 1e10,
    y: Math.round(((clientY - bbox.top) / bbox.height) * 1e10) / 1e10,
  };
}

export function storedMapCoordinatesToMarkerPosition(coordX, coordY, bbox) {
  if (!bbox) return { x: 0, y: 0 };
  return {
    x: (Number(coordX) * bbox.width) / ZOOM_LEVEL,
    y: (Number(coordY) * bbox.height) / ZOOM_LEVEL,
  };
}
